
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-services",
      function () {
        return require("private-next-pages/our-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-services"])
      });
    }
  